import { MessageSquareText } from "lucide-react";
import ChatPanel from "@/components/chat/ChatPanel";

export default function ChatPage() {
  return (
    <div className="space-y-4" data-testid="chat-page">
      <div>
        <h1 className="ds-page-title flex items-center gap-2"><MessageSquareText className="h-6 w-6 text-brand" /> Chat interna</h1>
        <p className="mt-1 text-sm text-slate-500">Comunicazioni in tempo reale tra sedi, Back Office e Direzione.</p>
      </div>
      <ChatPanel className="h-[calc(100vh-13rem)] min-h-[420px]" />
    </div>
  );
}
